<div class="confirm-delete-rule evir-font-default">
  <div mat-dialog-content>
    <p>{{ "delete selected rules confirmation" | i18next }}</p>
  </div>
  <div mat-dialog-actions align="center">
    <app-action-button class="no-btn" cdkFocusInitial title="no" (buttonClicked)="dialogRef.close()"></app-action-button>
    <app-action-button title="yes" (buttonClicked)="confirmDelete()"></app-action-button>

  </div>
</div>

<ng-template #deleteRuleError>
  <div>
    <p></p>
  </div>
</ng-template>
